const role_management_zh = {
  per_config:'权限配置',
  edit_role_info:'编辑角色信息',
  del_role:'是否删除角色',
  permissions_error:'请选择需要配置的权限',
  empty_role_name:'请输入角色名称',
  empty_super_role:'请选择上级角色',
  empty_alias:'请输入别名'
}

export default role_management_zh



// WEBPACK FOOTER //
// ./src/common/lang/role_management/role_management_zh.js